var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProgAdvancedPattern(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.709 41.9352C45.709 43.7659 44.2249 45.25 42.3942 45.25L4.2738 45.25C2.44308 45.25 0.958984 43.7659 0.958984 41.9352L0.958982 22.875C0.958981 10.5176 10.9766 0.500003 23.334 0.500002C35.6914 0.500001 45.709 10.5176 45.709 22.875L45.709 41.9352Z",
    fill: "#FA5C03"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgAdvancedPattern);
export default __webpack_public_path__ + "static/media/progAdvancedPattern.ffc1d92ca6b4a546d828e159e74b266b.svg";
export { ForwardRef as ReactComponent };